/**
 * Company: SPHMedia
 * Description: [Live blog]
 */
import { ReactElement } from "react";

type LiveBlogStyleProps = {
  wrapperStyle?: string;
};

type LiveBlogProps = {
  variant: "sidebar" | "body";
  liveBlogContent: string;
  styles?: LiveBlogStyleProps;
};

/**
 * SeasonalLiveBlog
 * Description: [LiveBlog widget]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function LiveBlog({
  variant,
  liveBlogContent,
  styles,
}: LiveBlogProps): ReactElement {
  const wrapperStyle = styles?.wrapperStyle || "w-[300px] h-full";

  return (
    <div
      className={`${variant == "sidebar" ? wrapperStyle : "w-full h-full"} flex flex-col border-red-100 border-2`}
    >
      <div className="text-white-100 text-[15px] font-semibold bg-red-100 p-xs">
        {`Blog BH`}
      </div>
      <div
        className="h-full"
        dangerouslySetInnerHTML={{ __html: liveBlogContent }}
      />
    </div>
  );
}
